module.exports = __webpack_public_path__ + "img/picsummacbook.428918be.png";